// Componente Liquidacion.vue
<template>
  <div class="animated fadeIn">
     <b-row>
      <b-col lg="12">
      
         <b-card>
            <b-row>
            
            <b-col class="col-sm-per" sm ="2">
                  <b-form-checkbox
                      v-model="datosFormulario.ckveranulados"
                      value="s"
                      unchecked-value="n"
                      @change="Asgckveranulados" 
                      >
                      Ver Anulados
                  </b-form-checkbox>
            </b-col>
            <b-col lg="4"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input size="sm"
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange"           
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >

                     <template v-slot="scope">
                      
                      <div v-if="title.prop == 'MONTOPESOS'"> 
                                 <b-link type="text"  v-if="scope.row.ESTADO == 'NU'" @click="mostrarModalErrorAnular1(scope.row.SINIESTRO,scope.row.BENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOPESOS}} </b-link> 
                                 <b-link type="text"  v-if="scope.row.ESTADO !== 'NU' && scope.row.SNTESTADO == 'TRA'" @click="mostrarModalErrorAnular2(scope.row.SINIESTRO,scope.row.BENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOPESOS}} </b-link>     
                                 <b-link type="text"  v-if="scope.row.ESTADO != 'NU' && scope.row.TIPO == 'P' && scope.row.SERV == 'BE' && scope.row.SNTESTADO != 'TRA' && (scope.row.PRCMANUAL == 'N' && scope.row.TRANSOLI == 'N')" @click="mostrarModalAnular1(scope.row.SINIESTRO,scope.row.BENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOPESOS}}</b-link>     
                                 <b-link type="text"  v-if="scope.row.ESTADO != 'NU' && scope.row.TIPO == 'P' && scope.row.SERV == 'BE' && scope.row.SNTESTADO != 'TRA' && (scope.row.PRCMANUAL == 'S' || scope.row.TRANSOLI == 'S')" @click="mostrarModalAnular2(scope.row.SINIESTRO,scope.row.BENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOPESOS}}</b-link>  
                                 <b-link type="text"  v-if="scope.row.ESTADO != 'NU' && scope.row.SERV != 'BE'" @click="mostrarModalAnular1(scope.row.SINIESTRO,scope.row.BENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOPESOS}}</b-link>             
                      </div> 
                      <p v-else>{{ formatter(scope.row, scope.column) }}</p>
                    </template>

                  </el-table-column> 

                </data-tables>
              </div>
            </b-col>
          </b-row>
          <p><b>Accesos rápidos :</b>  ** Click en Monto permite anular el pago.</p>
        </b-card>
      </b-col>  
    </b-row>  

    <!-- Error Anular Indemnización (cuando el estado de la liquidación es NU)-->
    <b-modal
      ok-only
      title="Error Anular Indemnización"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalErrorAnular1"
      @ok="modalErrorAnular1 = false"
      @cancel="modalErrorAnular1 = false"
    ><p>Pago ya anulado</p>
    </b-modal>

    <!-- Error Anular Indemnización (cuando el estado de la transferencia es TRA)-->
    <b-modal
      ok-only
      title="Error Anular Indemnización"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalErrorAnular2"
      @ok="modalErrorAnular2 = false"
      @cancel="modalErrorAnular2 = false"
    ><p>Transferencia ha sido realizada</p>
    </b-modal>

    <!-- Error Anular Indemnización (cuando la transferencia tiene estado TRA)-->
    <b-modal
      ok-only
      title="Error Anular Indemnización"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalErrorAnular2"
      @ok="modalErrorAnular2 = false"
      @cancel="modalErrorAnular2 = false"
    ><p>La transferencia ha sido realizada, no es posible anular este pago</p>
    </b-modal>

    <!-- Anular Indemnización Tipo 1 (cuando la transferencia no ha sido solicitada)-->
    <b-modal
      title="Anular Indemnización"
      cancel-title="Salir sin Anular"
      ok-title="Anular Indemnización"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalAnular1"
      @ok="anular1(datosFormulario.siniestroanu,datosFormulario.benefanu,datosFormulario.fecpagoanu)"
      @cancel="modalAnular1 = false"
    ><p>Se anulará esta indemnización</p>
    </b-modal>

    <!-- Anular Indemnización Tipo 2 (cuando la transferencia ya fue solicitada)-->
    <b-modal
      title="Anular Indemnización con Transferencia Solicitada"
      cancel-title="Salir sin Anular"
      ok-title="Anular Indemnización"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalAnular2"
      @ok="anular2(datosFormulario.siniestroanu,datosFormulario.benefanu,datosFormulario.fecpagoanu)"
      @cancel="modalAnular2 = false"
    ><p>Se anulará esta indemnización con transferencia solicitada, avise a Tesorería</p>
    </b-modal>

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarSiniestros from "@/components/services/apiGarSiniestros";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  // name: "Polizas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {

    nrosiniestro: String,
    fedesde: Datepicker,
    fehasta: Datepicker
 
  },

  components: {
    cSwitch
  },
  
  // filters: {    
  //   formateaFecha: (value, column) => {  
      
  //     if(!value || value===undefined ) 
  //       return "";
  //     if (column=='FECPAGO'){
  //       console.log(value, this);
  //        return this.configurarFechaLat(this.convierteFecha(value));
  //     }
  //     else {
  //        return value;
  //     }
  //   },  
  // },
  data: function() {
    return {
      tabIndex: 1,
      tieneAcceso: true,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      mostrar:false,
      
      variant: "",
      mensaje: "",

      data: [],
      dataLiqPer: [],
      multipleSelection: [],

      modalErrorAnular1: false,
      modalErrorAnular2: false,
      modalAnular1: false,
      modalAnular2: false,

      datosFormulario: {
        servicio:"",
        codliquidador: "",
        nomliquidador: "",
        feinicio:"",
        fefin:"",
        feiniciov:"",
        fefinv:"",
        codejecutivo: "",
        modaltitle:"",
        transoli: "",
        prcmanual: "",
        benefanu:"",
        siniestroanu:"",
        fecpagoanu:"",
        sntestado:"",
        ckveranulados:""

     },

      titles: [
       {
          prop: "FELIQUIDACION",
          label: "Fecha Liquidación",
          align: "center",
          minwidth: "150",
        },
       {
          prop: "RECEPTOR",
          label: "Receptor",
          align: "left",
          minwidth: "350",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONTO",
          label: "Monto",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "TIPOCAMBIO",
          label: "Tipo de Cambio",
          align: "center",
          minwidth: "130",
        },
        {
          prop: "LOCMONEDA",
          label: "Moneda Loc.",
          align: "center",
          minwidth: "110",
        },
        {
          prop: "MONTOPESOS",
          label: "Monto en Pesos ",
          align: "right",
          minwidth: "130",
        },
        {
          prop: "FECPAGO",
          label: "Fecha de Pago",
          align: "center",
          minwidth: "130",
        },
        {
          prop: "LIQADE",
          label: "T",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "SERV",
          label: "Servicio",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "TIPO",
          label: "Tipo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "DESCRIPCION",
          label: "Descripción",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "OBSERVACION",
          label: "Observación",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "ESTADO",
          label: "Estado",
          align: "center",
          minwidth: "100",
        }, 
        {
          prop: "USUARIO",
          label: "Usuario",
          align: "center",
          minwidth: "100",
        }, 
       
  
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      mensajeValidacionCampo: {},
      valEjecutivos: [],

      tableProps: {
        showSummary: false,
        maxHeight: 400,
        rowKey: "Siniestro"
      },

   
    }
  },

  components:{
    Datepicker,
    Multiselect
  },

  methods: {

    Asgckveranulados(checked){

      this.buscar(checked);

    },

  mostrarModalErrorAnular1(p_siniestro, p_beneficiario, p_fecpago){
        this.datosFormulario.siniestroanu = p_siniestro;
        this.datosFormulario.benefanu = p_beneficiario;
        this.datosFormulario.fecpagoanu = p_fecpago;
        this.modalErrorAnular1 = true;
    },  

    mostrarModalErrorAnular2(p_siniestro, p_beneficiario, p_fecpago){
        this.datosFormulario.siniestroanu = p_siniestro;
        this.datosFormulario.benefanu = p_beneficiario;
        this.datosFormulario.fecpagoanu = p_fecpago;
        this.modalErrorAnular2 = true;
    },   

  mostrarModalAnular1(p_siniestro, p_beneficiario, p_fecpago){
        this.datosFormulario.siniestroanu = p_siniestro;
        this.datosFormulario.benefanu = p_beneficiario;
        this.datosFormulario.fecpagoanu = p_fecpago;
        this.modalAnular1 = true;
    },

     anular1(p_siniestro, p_beneficiario, p_fecpago){
      apiGarSiniestros
          .anular_liquid(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_siniestro,
            p_beneficiario,
            p_fecpago,
            'N'
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Anular Indemnización",
                "Se anuló indemnización",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            this.datosFormulario.ckveranulados = "s";
            this.buscar("s");
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    mostrarModalAnular2(p_siniestro, p_beneficiario, p_fecpago){
       
        this.datosFormulario.siniestroanu = p_siniestro;
        this.datosFormulario.benefanu = p_beneficiario;
        this.datosFormulario.fecpagoanu = p_fecpago;
        this.modalAnular2 = true;
    },

    anular2(p_siniestro, p_beneficiario,  p_fecpago){
        apiGarSiniestros
          .anular_liquid(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_siniestro,
            p_beneficiario,
            p_fecpago,
            'S'
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Anular Indemnización",
                "Se anuló indemnización",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
             this.datosFormulario.ckveranulados = "s";
             this.buscar("s");
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });

    },


formatter(row, column) {
      // console.log(row, column);
       if ((column.property == "FECPAGO" || column.property == "FELIQUIDACION") && row[column.property]) {
           return this.configurarFechaLat(this.convierteFecha(row[column.property])
        )
       
       }
       else if ((column.property == "RECUMONTO" || column.property == "RECUMONTOPESOS" ||
                 column.property == "MONTO" || column.property == "MONTOPESOS" ||column.property == "TIPOCAMBIO" ||
                 column.property == "SDOSALDO" ) && row[column.property]){
          if (row[column.property] == 0 || row[column.property] == "0") {
            return row[column.property];
          } else {
            return this.$numeral(row[column.property]).format("0,0.00");
          }

       }
      else {
        return row[column.property];
      }
    
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Siniestros Sin Liquidador</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["SINIESTRO"] == undefined){
          this.data[key]["SINIESTRO"] = "";
        }
        if(this.data[key]["POLIZA"] == undefined){
          this.data[key]["POLIZA"] = "";
        }
        if(this.data[key]["PRODUCTO"] == undefined){
          this.data[key]["PRODUCTO"] = "";
        }
        if(this.data[key]["AFIANZADO"] == undefined){
          this.data[key]["AFIANZADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["MONPOL"] == undefined){
          this.data[key]["MONPOL"] = "";
        }
        if(this.data[key]["MTODENUN"] == undefined){
          this.data[key]["MTODENUN"] = "";
        }
        if(this.data[key]["FEDENUN"] == undefined){
          this.data[key]["FEDENUN"] = "";
        }
        if(this.data[key]["EJESIN"] == undefined){
          this.data[key]["EJESIN"] = "";
        }
        if(this.data[key]["ASISIN"] == undefined){
          this.data[key]["ASISIN"] = "";
        }
        if(this.data[key]["OBSERVACION"] == undefined){
          this.data[key]["OBSERVACION"] = "";
        }
        if(this.data[key]["TAREACREADA"] == undefined){
          this.data[key]["TAREACREADA"] = "";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["POLIZA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRODUCTO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["AFIANZADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONPOL"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MTODENUN"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FEDENUN"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJESIN"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASISIN"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["OBSERVACION"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["TAREACREADA"] + "</td>\n";

        cuerpo += "</tr>\n";
      }


      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },    

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
      return apiGarSiniestros
        .pre_insertar_sinliq(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.nrosiniestro
        )
        .then((response) => {
          this.dataVerAnulados  = response.data.res;
          
          // Bloqueo usuario no valido
          // if (response.data.args_out.usuarioval == "s") {
          //   this.tieneAcceso = true;
          // } else {
          //   this.tieneAcceso = false;
          // }
          
          this.datosFormulario.ckveranulados = this.dataVerAnulados[0]["VERANULADOS"];
  
          this.buscar(this.datosFormulario.ckveranulados);
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    
    buscar(veranulados) {
            this.$Progress.start(); 
            return apiGarSiniestros
              .recuperar_liquid(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.nrosiniestro,
                veranulados
              )  
              .then(response => {
                
                this.data = response.data.res1;
                this.pagina = this.paginaAnterior;
                this.$Progress.finish();
                // this.datosFormulario.cantsinliq = response.data.args_out.cantsinliq;
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
        },
    
      export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor];
            obj.text = data[i][texto];
          }
          arr.push(obj);
          
      }
      return arr;
    },
  },
      
  mounted() {
     this.pagina = Number(this.$route.query.pagina);
     this.pre_insertar();
  },
 watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

 data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            if (lista[index]["chk"] == "1"){
              this.toggleSelection([lista[index]]);
            }
        }
      })
    } 
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>

.derecha   { float: right; color: #20a8d8;}
.izquierda { float: left;  }

  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}

.label-blanco{
  color: #fff;
}
</style>